<template>
  <section class="section">
    <div class="container">
      <div class="section-header reveal">
        <span class="eyebrow">My Skill</span>
        <h2 class="heading-lg">Elevated Designs Personalized the Best Experiences</h2>
      </div>

      <div class="skills-grid">
        <div class="skills-col reveal reveal-delay-1">
          <h3 class="skills-col__title">Design Skill</h3>
          <div
            v-for="skill in DESIGN_SKILLS"
            :key="skill.name"
            class="progress-item"
          >
            <div class="progress-item__head">
              <span class="progress-item__label">{{ skill.name }}</span>
              <span class="progress-item__value">{{ skill.value }}%</span>
            </div>
            <div class="progress-item__track">
              <div
                class="progress-item__fill"
                :style="{ '--progress': `${skill.value}%` }"
              ></div>
            </div>
          </div>
        </div>

        <div class="skills-col reveal reveal-delay-2">
          <h3 class="skills-col__title">Development Skill</h3>
          <div
            v-for="skill in DEV_SKILLS"
            :key="skill.name"
            class="progress-item"
          >
            <div class="progress-item__head">
              <span class="progress-item__label">{{ skill.name }}</span>
              <span class="progress-item__value">{{ skill.value }}%</span>
            </div>
            <div class="progress-item__track">
              <div
                class="progress-item__fill"
                :style="{ '--progress': `${skill.value}%` }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { DESIGN_SKILLS, DEV_SKILLS } from "@/constants/site";
import { useScrollReveal } from "@/composables/useScrollReveal";

useScrollReveal();
</script>

<style scoped>
.skills-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
}

@media (min-width: 768px) {
  .skills-grid {
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
  }
}

.skills-col__title {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--color-text);
  margin: 0 0 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-border);
}
</style>
